export default __webpack_public_path__ + "84460ba4973f59210d4eded4577bddd6.png";